import { MAX_MOBILE_WIDTH } from '@constants';

import { isMobile } from './isMobile';

export function isMobileScreen() {
	return !IS_SSR ? window?.innerWidth <= MAX_MOBILE_WIDTH : isMobile();
}
